module.exports = __webpack_public_path__ + "static/media/innocent-4.98701de0.png";